<template>
  <b-card no-body style="border: none; height: 100%; margin: 0;">
    <b-table no-provider-paging striped bordered hover responsive id="my-table" :items="tableData"
             :per-page="perPage"
             :current-page="currentPage"
             tbody-tr-class="test"
             :fields="fields" v-on:row-clicked="rowClicked"
             class="custom-auto-height">
      <template v-slot:cell(offen)="row">
        <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
        <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="row.item.offen === 0 && row.item.art === 'AU'"></book-open-page-variant-icon>
        <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-if="row.item.offen === 1 && row.item.art === 'AU'"></check-bold-icon>
        <currency-eur-icon class="icon-1_5x" fillColor="#484848" style="color: black" :size="72" v-if="row.item.offen === 3 && row.item.art === 'AU'"></currency-eur-icon>
        <close-circle-icon class="icon-1_5x" fillColor="#ac121b" style="color: red" :size="72" v-if="row.item.art === 'DC'"></close-circle-icon>
      </template>
      <template v-slot:cell(details)="row">
        <b-button variant="primary" size="sm" v-if="!row.detailsShowing" @click="row.toggleDetails">
          <i class="fa fa-chevron-down"></i>
        </b-button>
        <b-button variant="primary" size="sm" v-if="row.detailsShowing" @click="row.toggleDetails">
          <i class="fa fa-chevron-up"></i>
        </b-button>
      </template>

      <template #row-details="row">
        <b-row>
          <b-col>
            <b-card class="mb-0">
              <template #header>
                <strong>Details</strong>
              </template>
              <b-row >
                <b-col md="8">
                  <p><b>Aufgabentext:</b></p>
                  <span style="white-space: pre-line">{{row.item.gi_memo}}</span>
                </b-col>
                <b-col >
                  <b-row><p><b>Anhänge: </b>
                    <a style="margin-left: 15px"
                       v-for="item in (row.item.anlagen === null ? '' : row.item.anlagen).split(';')"
                       v-if="item !== ''"
                       target="_blank"
                       v-on:click.prevent="showFile(url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=A', row.item, item)"
                       :href="url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=A'">
                      {{item}};
                    </a></p></b-row>
                  <b-row v-if="row.item.modul === 'mm'"><p><b>Position: </b>
                    <a style="margin-left: 15px"
                       target="_blank"
                       :href="gpsLink(row.item)">Zur Position
                    </a></p></b-row>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col md="10"></b-col>
                <b-col class="text-right">
                  <b-button variant="primary" class="btn-pill" v-on:click="rowClicked(row.item)">
                    &nbsp;Zur Aufgabe
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </template>
    </b-table>
    <div class="mt-3 custom-flex-0">
      <b-pagination v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table" align="center"></b-pagination>
    </div>
  </b-card>
</template>

<script>
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import CurrencyEurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle';
import {Server_URL, Server_URL_MAENGELMELDER} from "../../shared/utils";
import {arrayBufferToBase64, decryptAES, decryptFile} from "../../shared/crypto";


export default {
  name: 'AnfragenTable',
  components: {
    BookOpenPageVariantIcon, CheckBoldIcon, CurrencyEurIcon, CloseCircleIcon
  },
  props:{
    tableData: {
      type: Array,
      default: () => []
    },
    rowClickCallback: {
      type: Function,
      default: undefined
    },
    showFreigabe: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    allGroups: {
      type: Map,
    }

  },
  mounted() {
    if (!this.showIcon) {
      this.fields.shift();
    }
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
  },
  data: () => {
    return {
      isBauhof: false,
      filename: "",
      fields: [
        {key: 'offen', label: 'Typ'},
        {key: 'gi_match', label: "Aufgabe - Wo"},
        {key: 'gi_auf_ext', label: 'Aufgabenbezeichnung'},
        {key: 'datum', label:"Vergabe", formatter: 'dateToString'},
        {key: 'ziel_datum', label:"Termin", formatter: 'dateToString'},
        {key: 'kassen_datum', label:"Ablehnung", formatter: 'dateToString'},
        /*{key: 'auftraggeber', label:"Auftraggeber", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (item.modul === "mm") {
              return "Mängelmelder"
            }
            let res = JSON.parse(sessionStorage.getItem(item.auftraggeber));
            if (res === null) {
              return value;
            }
            return res.username;
          }},*/
        {key: 'sachbearbeiter', label:"Aufgabensteller", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (item.modul === "mm") {
              return "Mängelmelder"
            } else if (item.modul === "bk") {
              return "Baumkontrolle";
            } else if (item.modul === "k1") {
              return "Spielplatzkontrolle";
            } else if (item.modul === "k2" || item.modul === "k4") {
              return "GPS-Nachweis";
            } else if (item.modul === "k3") {
              return "Straßenkontrolle";
            } else if (item.modul === "k5") {
              return "Fast-Task";
            }
            let res = JSON.parse(sessionStorage.getItem(item.sachbearbeiter));
            if (res === null) {
              return value;
            }
            return res.username;
          }},
        {key: 'a_nehmer', label:"Aufgabennehmer", formatter: "formateAuftragnehmer"},

        {details: "Details"}
      ],
      currentPage: 1,
      perPage: 20,
      url: Server_URL,
      urlMm: Server_URL_MAENGELMELDER,
    }
  },
  computed: {
    items: function() {
      const items =  this.tableData;
      return Array.isArray(items) ? items : items()
    },
    rows() {
      return this.tableData.length
    }
  },
  methods: {
    rowClicked(item, index, target) {
      this.$router.push("/auftraege/auftrag/"+item.id);

      if (this.rowClickCallback !== undefined) {
        this.rowClickCallback(item, index);
      }
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    formateMemo(value) {
      if (value === null) {
        return "";
      }
      if (value.length > 80)
        return value.substring(0,80) + '...';
      else
        return value;
    },
    formateMoney(value) {
      if (value === null) {
        return "";
      }
      return ""+value+" €"
    },
    showFile(href, item, filename) {
      this.filename = filename;
      if (sessionStorage.getItem("aes") !== null && (item.module !== "mm" || this.isBauhof )) {
        this.$http.get(
            href, {responseType: 'blob'}
        ).then(this.onFileOk, this.responseError)
      } else {
        window.open(href, "_blank")
      }
    },
    onFileOk(response) {
      response.blob().then(blob => {
        blob.arrayBuffer().then(binary => {
          decryptFile(sessionStorage.getItem("aes"), new Uint8Array(binary)).then(res => {
            if (this.isBauhof) {
              try {
                windowsFileService.onFile(
                    arrayBufferToBase64(res),
                  this.filename,
                  blob.type
                ).then(r => {
                  if (r && !r.Success) {
                    console.log(r)
                  }
                }).catch(e => {
                  console.log(e)
                });
              } catch (e) {
                console.log(e);
              }
              return
            }
            const b = new Blob([res], {type: blob.type});
            const blobUrl = URL.createObjectURL(b);
            window.open(blobUrl, '_blank');
          }).catch(err => {
            if (this.isBauhof) {
              try {
                windowsFileService.onFile(
                    arrayBufferToBase64(binary),
                  this.filename,
                  blob.type
                ).then(r => {
                  if (r && !r.Success) {
                    console.log(r)
                  }
                }).catch(e => {
                  console.log(e)
                });
              } catch (e) {
                console.log(e);
              }
              return
            }
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
          })
        })
      });
    },
    formateAuftragnehmer(value, key, item) {
      if (item === null) {
        return null;
      }

      let res = JSON.parse(sessionStorage.getItem(item.a_nehmer));
      if (res === null) {
        if(item.a_nehmer in this.allGroups) {
          return this.allGroups[item.a_nehmer]
        }

        return value;
      }
      return res.first_name + " " + res.surname;
    },
    responseError(response) {
      console.log(response)
    },
    gpsLink(item) {
      return Server_URL_MAENGELMELDER + "/#/location/show?lat="+item.lat+"&lon="+item.lon
    },
  }
}
</script>

<style scoped>

</style>
